const files = require.context('../../jsx/pages', true, /\.moke\.js$/i);
const fileskeys = files.keys();
export const entries = {
    ...fileskeys.map(key=>files(key).default).reduce((o,n)=>({...o,...n}),{})
}
export default entries;